import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      plans: {
        keyArgs: [],
      },
    },
  },
};
